<div class="flex-row">
  <div class="mat-headline-3 fw-600 mb-24">Learn about SaaS</div>
</div>
<div class="p-20">
  <div class="flex flex-row">
    <div class="flex flex-col w-50-percent">
      <div class="mat-headline-5 fw-600 mb-10">Discover More About The Temenos Banking Cloud</div>
      <div class="mat-subtitle-2 fw-500 mb-24">Get detailed information and guidance to using TTBC and services.
      </div>
      <div *ngFor="let topics of saasTopics;let i = index"
        [ngClass]="{'selected-tab': currentTopic === i }" class="flex flex-row items-center topics-details mb-16 cursor-pointer"
        (click)="goToTopic(i)">
        <img src="{{topics.imgSrc}}" class="h-40 w-40 mr-20 ml-14">
        <div class="flex flex-col ml-4">
          <div class="mat-headline-6 fw-600 mb-8 mt-20">{{topics.title}}</div>
          <div class="mat-subtitle-2 fw-500 mb-16"></div>
        </div>
      </div>
    </div>
    <div class="vertical-line ml-20 mr-20 height-auto"></div>
    <div class="flex flex-col w-50-percent">
		<div *ngIf="currentTopic === 0">
			<div class="flex flex-row justify-between justify-end border-bottom">
				<div class="flex items-center mat-subtitle-2 fw-600 w-100-percent cursor-pointer pt-8 pb-8 p-4 mb-0"
					[ngClass]="{'selected-tab': currentArcTopic === i }"
					*ngFor="let architectTopics of saasArchitectTopics;let i = index" (click)="goToArchitectTopic(i)">
					{{architectTopics}}</div>
			</div>
			<ng-container *ngIf="currentArcTopic === 0">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Integration</div>
					<div class="mat-subtitle-2 fw-500 ml-4">The integration of the portal is API first. We have deep and
						broad
						experience in integrating ecosystem partners across the globe. Within TTBC we have over 1000
						APIs
						in the
						catalogue ready to be used as accelerators. All of this experience means improved speed to market
						and
						a
						lower cost to implement.</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentArcTopic === 1">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Extensibility</div>
					<div class="mat-subtitle-2 fw-500 ml-4">
						The extensibility provides the ability to implement customer specific in order to meet their
						business needs without impacting the ability to upgrade the underlying services.
						This means as you always relay on the latest technology and you never have to upgrade again through
						the provision continues updates.
						This process includes all updates and patching of infrastructure, security and software.
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentArcTopic === 2">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Security & Privacy</div>
					<div class="mat-subtitle-2 fw-500 ml-4">We recognise the importance of security and privacy of your
						customers' data and therefore invest heavily in our service. Our dedicated security team continues
						to
						develop the service on an ongoing basis thus minimising risks and also ensuring that we continue to
						retain
						high-level certifications and attestations including SOC2,ISO2701,17,18, 22301 & CSA.
						<br>All of the service you receive is monitored on a 24/7 - 365 basis by our dedicatedsecurity
						centre
						whose sole duty is to protect the customer data.</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentArcTopic === 3">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Platform</div>
					<div class="mat-subtitle-2 fw-500 ml-4">We provide a single service by a single vendor contracted under
						service levels. End to end coverage from Risk, Security through to platform management and
						performance
						all
						under one service. The ability for clients to determine where the data centres are located from the
						wide
						choice available.
						<br>At all times there is a team of cloud solution architects, security architects and
						governance
						analysts who are working to continually update the service in orderto provide an evergreen service.
					</div>
				</div>
			</ng-container>
		</div>
		<div *ngIf="currentTopic === 1">
			<div class="flex flex-row justify-end border-bottom">
				<div class="flex items-center mat-subtitle-2 fw-600 w-100-percent cursor-pointer pt-8 pb-8 p-4 mb-0 ws-nowrap"
					[ngClass]="{'selected-tab': currentOperationTopic === i }"
					*ngFor="let operationsTopics of saasOperationsTopics;let i = index" (click)="goToOperations(i)">
					{{operationsTopics}}</div>
			</div>
			<ng-container *ngIf="currentOperationTopic === 0">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Governance</div>
					<div class="mat-subtitle-2 fw-500 ml-4">Governance is the foundation of the Temenos Banking Cloud
						service.
						By investing heavily in our range of international standards we provide our clients with
						assurance
						on how the service is being run and delivered on a day to day basis.<br><br>

						These certificates and external audits are made available to our clients in order that they can
						incorpoarte them into their onward reporting for audit, board reporting and ultimately to the
						regulator.<br><br>

						Our dedicated governance team continues to retain a high level of certifications and attestations
						including SOC2, ISO2701,17,18, 22301 & CSA.
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentOperationTopic === 1">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4 ws-nowrap">Change Management</div>
					<div class="mat-subtitle-2 fw-500 ml-4">Temenos understands that moving to TTBC is only the start and
						that
						our clients would want to continue to make changes so they will remain competitive and relevant to
						their
						customers.<br><br>

						In order to maintain best in class functionality, performance & security, Temenos provides
						continuous
						updates in order to maintain the high standards of the service on an ongoing basis.<br><br>

						The coordination of these change journeys is a joint activity based on the on-going governance
						reviews
						and
						a rolling 6-month program of change.
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentOperationTopic === 2">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Support</div>
					<div class="mat-subtitle-2 fw-500 ml-4">Temenos provides end-to-end support for the service including
						all
						infrastructure, application and technical management. This is underpinned by a 24x7x365 service
						desk and
						associated critical support centre.The activities provided include but are not limited to:
						<ul class="pl-32">
							<li> Provision of new environments
							</li>
							<li> Running Close Of Business (COB)
							</li>
							<li>Performance monitoring and tuning</li>
							<li>Scaling of application environment</li>
							<li>Monitoring of application integration</li>
							<li>Back up and restore</li>
							<li>Real user monitoring</li>
							<li> Patching of all infrastructure, platform and application components
							</li>
							<li>Continuous Updates</li>
							<li>IT Service Continuity testing</li>
						</ul>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentOperationTopic === 3">
				<div class="flex flex-col mt-38">
					<div class="mat-headline-6 fw-600 ml-4">Change Management</div>
					<div class="mat-subtitle-2 fw-500 ml-4">
						<span class="fw-600">Build the Bank</span><br>
						Temenos works with the client to ensure close alignment of the teams of the teams at all stages of
						the
						journey. When we build the bank we make sure there is a clear RACI model established to ensure
						clarity
						and
						clear lines of responsibility between Temenos and the client.<br><br>
						<span class="fw-600">Run the Bank</span><br>
						We spend a lot of time aligning the service in order to support the bank in achieving their
						operational
						goals and ultimately the customer benefits. This is achieved through a joint operations manual which
						lays
						out all of the fundamental activities that happen across a year.
					</div>
				</div>
			</ng-container>
		</div>
    </div>
  </div>
</div>
